import { useRegistrationStore } from '../../hooks';
import { ApiKeyTemplateHeaderView } from '../../components/ApiKeyTemplateHeaderView';

export const ApiKeyTemplateHeader = () => {
  const { onOpenModal } = useRegistrationStore();

  return <ApiKeyTemplateHeaderView handleClickRegistration={onOpenModal} />;
};
